export function descendingComparator(a, b, orderBy) {
    if (orderBy === 'captcha') {
        if (typeof b[orderBy] === 'undefined' && typeof a[orderBy] === 'undefined') {
            return 0;
        }
        if ((b[orderBy] === true) && ( a[orderBy] === false || typeof a[orderBy] === 'undefined')) {
            return -1;
        }
        if ((b[orderBy] === false || typeof b[orderBy] === 'undefined') && (a[orderBy] === true)) {
            return 1;
        }
        if ((b[orderBy] === false) && ( typeof a[orderBy] === 'undefined')) {
            return -1;
        }
        if (( typeof b[orderBy] === 'undefined') && (a[orderBy] === false)) {
            return 1;
        }
    } else {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
    }

    return 0;
}

export function getComparator(order, orderBy) {
    if (!order || !orderBy) return null
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
    if (!comparator) return array
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
export function createData(id, account, site, type, start, end, left, active, edit, remove, smt) {
    return {id, account, site, type, start, end, left, active, edit, remove, smt};
}

export function getSiteName(siteId, sites) {
    return sites.find(el => el.id == siteId).name;
}
